import React, { useEffect, useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram } from '@fortawesome/free-brands-svg-icons';
import { faSoundcloud } from '@fortawesome/free-brands-svg-icons';
import './App.css';

// Custom Resident Advisor icon component - actual RA logo representation
const ResidentAdvisorIcon = () => (
  <svg
    className="fa-icon"
    viewBox="0 0 83 40"
    fill="currentColor"
    style={{ width: '2.5rem', height: '1.5rem' }}
    aria-label="RA logo"
  >
    <title>RA</title>
    <g fill="none" fillRule="evenodd">
      <path fill="none" d="M0 0h24v24H0z"></path>
      <path d="M82.092 32.018c.556-.533.908-1.28.908-2.113 0-.802-.38-1.523-.9-2.051L58.665 4.3l-7.073 7.11 18.45 18.543h-26.14c-1.278-.038-2.29-.469-3.147-1.304l-11.73-11.788a6.828 6.828 0 00-4.689-1.888l-.017.001H10.004v-4.92h14.825c2.938.002 5.559 1.21 7.48 3.15l8.749 8.793 7.073-7.11-8.92-8.963C35.485 2.234 30.45 0 24.805 0H0v25.027h20.978v.002a4.919 4.919 0 013.486 1.48L35.95 38.053A6.74 6.74 0 0040.449 40h31.733a4.911 4.911 0 003.423-1.45l6.491-6.524-.004-.008" fill="currentColor"></path>
    </g>
  </svg>
);

const WhoWeAre = () => {
  const parallaxRef = useRef(null);
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (parallaxRef.current) {
        const offset = window.scrollY * -0.08; // subtle upward movement
        parallaxRef.current.style.transform = `translateY(${offset}px)`;
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="who-we-are">
      <div className="top-section">
        <img
          src="/images/Eloisa-Carotin.jpg"
          alt="Who We Are"
          className={`who-image ${imageLoaded ? 'loaded' : 'loading'}`}
          onLoad={() => setImageLoaded(true)}
          onError={() => setImageLoaded(true)} // Still show content even if image fails
        />
        <h1 className={`who-title ${imageLoaded ? 'loaded' : 'loading'}`}>WHO<br />WE ARE</h1>
      </div>

      {/* Apply parallax here */}
      <div className="parallax-content" ref={parallaxRef}>
        {/* Mobile-only title that appears above paragraph */}
        <h1 className="who-title">WHO<br />WE ARE</h1>
        
        <div className="paragraph-text">
          <p>
            We're a Berlin-based collective of music lovers, artists, and promoters building community through sound.
            <br /><br />
            Since 2023, we’ve been hosting events with carefully curated <span className="highlight">FLINTA*-focused lineups</span>, creating dance floors where
            musical quality, intention, and community come first. Our events have built a strong reputation within Berlin’s
            electronic music scene and beyond.
            <br /><br />
            Through our <span className="highlight">booking agency</span>, we represent selected FLINTA* artists and connect them with clubs, festivals, and platforms aligned with their sound
            and vision. Representation for us is not a statement — it’s what drives the culture forward.
            <br /><br />
            Let's make space for something better.
          </p>
        </div>

        {/* Social links section */}
        <div className="artist-links">
          <a href="https://www.instagram.com/silikon.official/" target="_blank" rel="noopener noreferrer" className="social-link yellow-strike">
            <FontAwesomeIcon icon={faInstagram} className="fa-icon" />INSTAGRAM
          </a>
          <a href="https://soundcloud.com/silikon-official" target="_blank" rel="noopener noreferrer" className="social-link yellow-strike">
            <FontAwesomeIcon icon={faSoundcloud} className="fa-icon" />SOUNDCLOUD
          </a>
          <a href="https://ra.co/promoters/132855" target="_blank" rel="noopener noreferrer" className="social-link yellow-strike">
            <ResidentAdvisorIcon />RESIDENT ADVISOR
          </a>
        </div>

        {/* Fine print placeholder - center aligned */}
        <div className="fine-print">
          <p>Imprint: silikon c/o Julia Dillan · Streckfußstraße 14a, 13125 Berlin · agency@silikon.berlin · VAT: DE369817331</p>
        </div>
      </div>
    </div>
  );
};

export default WhoWeAre;